class BlockChiffres {
  constructor() {
    this._init();
  }

  _init() {
    const numbers = document.querySelectorAll('[data-number]');

    const inViewport = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) animNum(entry.target);
      });
    };

    numbers.forEach(function (number) {
      const observer = new IntersectionObserver(inViewport);
      observer.observe(number);
    });

    function animNum(number) {
      if (number._isAnimated) return;
      number._isAnimated = true;

      let countTo = number.getAttribute('data-number');
      animate(
        function (newValue) {
          var text;
          if (countTo % 1 == 0) text = Math.ceil(newValue);
          else if ((countTo * 10) % 1 == 0) text = newValue.toFixed(1);
          else text = newValue.toFixed(2);
          number.innerHTML = numberWithSpaces(text);
        },
        0,
        countTo,
        3000,
        (x) => x
      );
    }

    function animate(render, from, to, duration, timeFx) {
      let startTime = performance.now();
      requestAnimationFrame(function step(time) {
        let pTime = (time - startTime) / duration;
        if (pTime > 1) pTime = 1;
        render(from + (to - from) * timeFx(pTime));
        if (pTime < 1) {
          requestAnimationFrame(step);
        }
      });
    }

    function numberWithSpaces(x) {
      let parts = x.toString().split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      return parts.join('.');
    }
  }
}

export const blockChiffres = new BlockChiffres();
